import "admin-lte/dist/css/adminlte.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import VehicleFormModal from "./VehicleFormModal";
import apiManager from "../../api/apiManager";
import API_ENDPOINTS from "../../api/apiEndpoints";
import { formatPhoneNumber } from "../../shared/helpers/formUtils";
import { useVehicleContext } from "../../context/VehicleContext";
import { useLocalization } from "../../context/LocalizationContext";
import getUserRoleFromJWT from "../../shared/helpers/getUserRoleFromJWT";
import { UserRole } from "../../shared/Enums/UserRole";

const SelectVehicle = () => {
  const { t: localization } = useLocalization();
  const navigate = useNavigate();
  const ctx = useVehicleContext();
  const {
    customer: customerData,
    vehicle: vehicleProp,
    customerId,
    vehicleId,
    dealershipId,
    setCustomer,
    setVehicle,
    setCustomerId,
    setVehicleId,
    stepper,
  } = ctx;
  const [vehicleData, setVehicleData] = useState(vehicleProp);
  const customerIdFinal = customerId;
  const [vehicleIdState, setVehicleIdState] = useState(vehicleId);
  const [odometer, setOdometer] = useState(
    (vehicleData && (vehicleData.odometer ?? vehicleData.mileage)) || "",
  );
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [odometerError, setOdometerError] = useState("");
  const validateOdometer = (val) => {
    if (val === "" || val == null) return "";
    if (!/^\d+$/.test(val)) return "Mileage must be digits only";
    if (val.length > 6) return "Mileage cannot exceed 6 digits";
    return "";
  };

  useEffect(() => {
    if (vehicleProp && vehicleProp.id !== vehicleData?.id) {
      setVehicleData(vehicleProp);
      setVehicleIdState(vehicleId);
    }
  }, [vehicleProp, vehicleId]);

  return (
    <div className="select-vehicle-content">
      <div className="form-card">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <label className="form-label">{localization("year")}</label>
            <div className="d-flex gap-2">
              <input
                className="form-control"
                value={vehicleData?.year || ""}
                disabled
              />
              <button
                type="button"
                className="btn btn-edit"
                onClick={() => setShowVehicleModal(true)}
              >
                <i
                  className="fa-solid fa-plus"
                  style={{ fontSize: "15px", color: "green" }}
                ></i>
              </button>
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">{localization("customer")}</label>
            <div className="d-flex gap-2">
              <input
                className="form-control"
                value={`${customerData?.firstName || ""} ${
                  customerData?.lastName || ""
                }`}
                disabled
              />
              <button
                type="button"
                className="btn btn-edit"
                onClick={() => {
                  navigate("/create-customer", {
                    state: {
                      goToCustomerStep: true,
                      customerId: customerId,
                      vehicleId: vehicleId,
                      customer: customerData,
                      vehicle: vehicleData,
                    },
                  });
                }}
              >
                <i
                  className="fa-solid fa-pen-to-square"
                  style={{ fontSize: "15px", color: "green" }}
                ></i>
              </button>
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">{localization("make")}</label>
            <div className="d-flex gap-2">
              <input
                className="form-control"
                value={vehicleData?.makeName || ""}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">{localization("address")}</label>
            <input
              className="form-control"
              value={customerData?.address1 || ""}
              disabled
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">{localization("model")}</label>
            <input
              className="form-control"
              value={vehicleData?.modelName || ""}
              disabled
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">{localization("body")}</label>
            <input
              className="form-control"
              value={vehicleData?.body || ""}
              disabled
            />
          </div>
          <div className="col-md-6">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-md-5 mb-2 mb-md-0">
                  <label className="form-label">{localization("city")}</label>
                  <input
                    className="form-control"
                    value={customerData?.cityOrLocality || ""}
                    disabled
                  />
                </div>
                <div className="col-md-3 mb-2 mb-md-0">
                  <label className="form-label">{localization("state")}</label>
                  <input
                    className="form-control"
                    value={customerData?.stateOrProvinceCode || ""}
                    disabled
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">{localization("zip")}</label>
                  <input
                    className="form-control"
                    value={customerData?.postalCodeOrZip || ""}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">{localization("engine")}</label>
            <input
              className="form-control"
              value={vehicleData?.engine || ""}
              disabled
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">{localization("phone")}</label>
            <input
              className="form-control"
              value={formatPhoneNumber(customerData?.phoneNumber) || ""}
              disabled
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">{localization("email")}</label>
            <input
              className="form-control"
              value={customerData?.email || ""}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">{localization("mileage")}</label>
            <input
              className={`form-control ${odometerError ? "is-invalid" : ""}`}
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={odometer}
              onChange={(e) => {
                let digitsOnly = e.target.value.replace(/[^0-9]/g, "");
                if (digitsOnly.length > 6) digitsOnly = digitsOnly.slice(0, 6);
                setOdometer(digitsOnly);
                setOdometerError(
                  digitsOnly === "" ? "" : validateOdometer(digitsOnly),
                );
              }}
              onBlur={() => setOdometerError(validateOdometer(odometer))}
              placeholder="Enter mileage"
            />
            {odometerError && (
              <div className="invalid-feedback d-block">{odometerError}</div>
            )}
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-6">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="mileageUnit"
                defaultChecked
              />
              <label className="form-check-label">
                {localization("miles")}
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="mileageUnit"
              />
              <label className="form-check-label">{localization("km")}</label>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center gap-2">
              <button
                className="btn btn-success"
                onClick={() => {
                  const err = validateOdometer(odometer);
                  if (err) {
                    setOdometerError(err);
                    return;
                  }
                  setCustomer(customerData);
                  setVehicle({
                    ...vehicleData,
                    odometer:
                      odometer !== ""
                        ? parseInt(odometer, 10)
                        : (vehicleData?.odometer ?? vehicleData?.mileage),
                    mileage:
                      odometer !== ""
                        ? parseInt(odometer, 10)
                        : vehicleData?.mileage,
                  });
                  setCustomerId(customerIdFinal);
                  setVehicleId(vehicleIdState);
                  if (dealershipId)
                    ctx.setDealershipId && ctx.setDealershipId(dealershipId);
                  if (stepper && stepper.current) stepper.current.to(3);
                }}
              >
                {localization("select_services")}
              </button>
              <button
                className="btn btn-cancel"
                onClick={() => {
                  const userRole = getUserRoleFromJWT();
                  navigate(
                    userRole === UserRole.DEALER_ADMIN
                      ? "/admin-dashboard"
                      : "/service-desk-dashboard",
                  );
                }}
              >
                {localization("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <VehicleFormModal
        isOpen={showVehicleModal}
        onClose={() => setShowVehicleModal(false)}
        onSave={async (newVehicleId) => {
          try {
            const vehicleRes = await apiManager.post(
              API_ENDPOINTS.CUSTOMER_GET_VEHICLE_BY_ID,
              { id: newVehicleId },
            );
            const fullVehicle = vehicleRes.data;
            const patchedVehicle = {
              ...fullVehicle,
              engine: fullVehicle.engine || fullVehicle.Engine || "",
              body: fullVehicle.body || fullVehicle.Body || "",
              subModelId:
                fullVehicle.subModelId || fullVehicle.subModelID || "",
              subModelName:
                fullVehicle.subModelName || fullVehicle.subModel || "",
            };
            setVehicleData(patchedVehicle);
            setVehicleIdState(newVehicleId);
          } catch (err) {}
        }}
        customerId={customerIdFinal}
        t={localization}
      />
    </div>
  );
};

export default SelectVehicle;
